import {AccountPageComponent, Content, Menu, MenuItem, MenuWithdrawIcon} from "../ui/AccountUI";
import {t} from "../i18n";
import {Redirect, Route} from "react-router";
import ProfilePage from "../profilepage/ProfilePage";
import TransactionPage from "../transactions/ui/deprecated/TransactionPage";
import UserLevel from "../userLevel/UserLevel";
import {useDispatch, useSelector} from "react-redux";
import {AppState} from "../RootReducer";
import BonusPage from "../bonus/BonusPage";
import MessagesPage from "../profilepage/MessagesPage";
import Footer from "../footer/Footer";
import {showCashier} from "../payments/DepositActions";
import {CashierSection} from "../payments/PaymentsReducer";
import {UserRewardsPage} from "../rewards/UserRewardsPage";
import {getLoggedIn} from "../selectors/user-selectors";
import React from "react";
import BalancesPage from "../profilepage/BalancesPage";
import TransactionsPage from "../transactions/ui/TransactionsPage";


interface Props {

}
export const AccountPage = (props : Props) => {
    const dispatch = useDispatch();
    const loggedIn = useSelector((app : AppState) => getLoggedIn(app));
    let userInfoLoaded  = useSelector((app : AppState) => app.user.userInfoLoaded)
    let showUserLevel  = useSelector((app : AppState) => {
        return app.settings && app.settings.settings && app.settings.settings.showUserLevel
    })
    if(!userInfoLoaded) {
        return <></>
    }

    if(!loggedIn) {
        return <Redirect to={"/"}/>
    }
    return (
       <>
           <AccountPageComponent>
            <div className={"account-page-menu-col"}>
               <Menu>
                   <MenuItem to={"/account/profile"}>
                       <i className={"material-icons"}>account_circle</i>{t("menu.profile")}
                   </MenuItem>
                   <MenuItem to={"/account/balances"}>
                       <i className={"material-icons"}>account_balance_wallet</i>{t("menu.balances")}
                   </MenuItem>
                   <MenuItem  to={"/account/transactions/wallet"} isActive="/account/transactions">
                       <i className={"material-icons"}>format_list_bulleted</i>{t("menu.transactions")}
                   </MenuItem>

                   {showUserLevel &&
                   <MenuItem to={"/account/vip-level"}>
                       <i className={"material-icons"}>military_tech</i>{t("menu.vip-level")}
                   </MenuItem>
                   }

                   <MenuItem to={"/account/bonus"}>
                       <i className={"material-icons"}>card_giftcard</i>{t("menu.bonus")}
                   </MenuItem>
                   <MenuItem to={"/account/rewards"}>
                       <i className={"material-icons"}>local_activity</i>{t("menu.rewards")}
                   </MenuItem>
                   <MenuItem to={"/account/messages"}>
                       <i className={"material-icons"}>mail</i>{t("menu.messages")}
                   </MenuItem>
                 </Menu>
                    <button ph-autocapture="true" ph-autocapture-event="withdraw" onClick={() => dispatch(showCashier(true, CashierSection.WITHDRAW))} className="btn btn-secondary withdraw-menu-button">
                            <MenuWithdrawIcon/>
                           {t("menu.withdraw")}
                    </button>
                </div>
               <Content>
                   <Route path={"/account/balances"} component={BalancesPage}/>
                   <Route path={"/account/profile"} component={ProfilePage} />
                   <Route path={"/account/transactions/:subsection?"} component={TransactionsPage} />
                   <Route path={"/account/bonus/:subsection?"} component={BonusPage} />
                   <Route path={"/account/messages/:id?"} component={MessagesPage}/>
                   <Route path={"/account/rewards"} component={UserRewardsPage} />
                   <Route path={"/account/vip-level"} component={UserLevel} />
               </Content>

           </AccountPageComponent>
           <Footer />
       </>
    )

}